import { AnimatePresence, motion } from "framer-motion";
import { EASE } from "./motion";
import { useCountdown } from "@/hooks/useCountdown";
import { APP_LAUNCH } from "@/lib/site";

const pad = (n) => String(n).padStart(2, "0");

const LAUNCH_LABEL = new Date(APP_LAUNCH).toLocaleString("it-IT", { day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" });

const Unit = ({ id, value, label }) => (
  <div className="flex flex-col border-r border-line px-4 py-4 last:border-r-0 sm:px-6">
    <span data-testid={`countdown-${id}`} className="relative block h-[1em] min-w-[2ch] overflow-hidden font-display text-4xl font-black leading-none tabular-nums sm:text-5xl">
      <AnimatePresence mode="popLayout" initial={false}>
        <motion.span key={value} className="block" initial={{ y: "100%" }} animate={{ y: "0%" }} exit={{ y: "-100%" }} transition={{ duration: 0.5, ease: EASE }}>
          {pad(value)}
        </motion.span>
      </AnimatePresence>
    </span>
    <span className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">{label}</span>
  </div>
);

export const Countdown = () => {
  const { days, hours, minutes, seconds, done } = useCountdown(APP_LAUNCH);
  if (done) {
    return <p data-testid="countdown-live" className="font-display text-2xl font-black uppercase text-acid">InkMaster è live!</p>;
  }
  return (
    <div data-testid="app-countdown">
      <p className="mb-3 font-mono text-[11px] uppercase tracking-[0.25em] text-smoke">
        Lancio previsto · <span className="text-bone">{LAUNCH_LABEL}</span>
      </p>
      <div className="inline-grid grid-cols-4 border border-line bg-ink">
        <Unit id="days" value={days} label="Giorni" />
        <Unit id="hours" value={hours} label="Ore" />
        <Unit id="minutes" value={minutes} label="Min" />
        <Unit id="seconds" value={seconds} label="Sec" />
      </div>
    </div>
  );
};

export const CountdownChip = () => {
  const { days, hours, minutes } = useCountdown(APP_LAUNCH);
  return (
    <span className="tabular-nums text-bone">
      {days}g {pad(hours)}h {pad(minutes)}m
    </span>
  );
};
